/** Fallback, wenn die API noch nicht geladen ist (z. B. öffentliche Buchung). */
export const FALLBACK_ARRIVAL_TYPES = [
  { value: "motorhome", label: "Wohnmobil", requires_vehicle_length: true },
  { value: "caravan", label: "Wohnwagen", requires_vehicle_length: true },
  { value: "tent_car", label: "Zelt mit Auto", requires_vehicle_length: false },
  { value: "tent_bike", label: "Zelt mit Fahrrad", requires_vehicle_length: false },
  { value: "tow_vehicle", label: "Zugfahrzeug", requires_vehicle_length: false },
  { value: "tent", label: "Zelt", requires_vehicle_length: false },
] as const;

/** @deprecated Verwenden Sie useArrivalTypes oder die API. */
export const ARRIVAL_TYPES = FALLBACK_ARRIVAL_TYPES.map(({ value, label }) => ({
  value,
  label,
}));

export function arrivalTypeLabel(
  value: string | null | undefined,
  types?: { code: string; name: string }[],
): string {
  if (!value) return "—";
  const fromApi = types?.find((t) => t.code === value)?.name;
  if (fromApi) return fromApi;
  return FALLBACK_ARRIVAL_TYPES.find((t) => t.value === value)?.label ?? value;
}
